<template>
    <div>
        <div class="th-dropdown" v-if="isEditMode">
            <label tabindex="0">
                <input v-model="inputSearch"
                       id="searchPnInput"
                       @blur="resetSuggestStatus" class="th-input w-[200px]" :placeholder="$t('inputPnPlaceholder')"/>
            </label>
            <ul v-if="inputSearch" tabindex="0" class="th-dropdown-content th-menu z-10 mt-1 w-[200px]">
                <span class="th-loading th-loading-spinner th-loading-xs" v-if="isLoadingList"></span>
                <template v-else-if="suggestList.length">
                    <li class="th-menu-item-ellipse" :title="item.PN" v-for="(item) in suggestList" :key="item.PATENT_ID" @click="handleChoosePN(item.PATENT_ID)" @mousedown.prevent>
                        {{ item.PN }}</li>
                </template>
                <p v-else class="text-center text-sm text-grey-60">{{ $t('suggestNoData') }}</p>
            </ul>
        </div>

        <button v-else class="th-btn th-btn-outline" @click="handleChangeEditMode">
            <IconCompare class="mr-2"/>
            <span>
                {{ $t('compareByPn') }}
            </span>
        </button>
    </div>
</template>

<script setup lang="ts">
import { watchEffect, ref, nextTick } from 'vue';
import IconCompare from '@/components/icons/IconCompare.vue'
import { debounce } from 'lodash';
import type { ISuggestList } from '@/types';
import { getSuggestList } from '@/infrastructure/api-functions';

const isEditMode = ref(false)
const isLoadingList = ref(false)
const inputSearch = ref('')
const suggestList = ref<ISuggestList[]>([])

function getSuggestPatentList() {
    if (!inputSearch.value) return
    suggestList.value = []
    getSuggestList(inputSearch.value.trim()).then((r) => {
        suggestList.value = r
    }).finally(() => { isLoadingList.value = false })
}

function resetSuggestStatus() {
    isEditMode.value = false
    inputSearch.value = ''
    isLoadingList.value = false
    suggestList.value = []
}

const debounceRequest = debounce(getSuggestPatentList, 500);

watchEffect(() => {
    const search = inputSearch.value
    if (search) {
        isLoadingList.value = true
        debounceRequest();
    }
})

const emits = defineEmits<{
    (e: 'update:handleChosen', id:string): void
}>()

function handleChoosePN(id:string) {
    resetSuggestStatus();
    emits('update:handleChosen', id)
}

function handleChangeEditMode() {
    isEditMode.value = true;
    nextTick(() => {
        const input = document.getElementById('searchPnInput')
        input?.focus()
    })
}

</script>
